<template>
  <div v-loading="pager.loading" class="material">
    <div class="material__left">
      <div class="flex-1 min-h-0">
        <div class="material-left__content scrollbar-style">
          <el-tree
            v-show="cateLists.length"
            ref="treeRef"
            node-key="id"
            :data="cateLists"
            empty-text="暂无数据"
            :highlight-current="true"
            :expand-on-click-node="false"
            :current-node-key="cateId"
            :props="{
              children: 'Child',
              label: 'material_name',
            }"
            @node-click="handleCatSelect"
          >
            <template v-slot="{ data }">
              <div class="flex flex-1 items-center min-w-0">
                <span class="flex-1 truncate">
                  <dynamic-tooltip
                    :content="data.material_name"
                    :open-delay="3000"
                    style="width: 148px"
                  />
                </span>
              </div>
            </template>
          </el-tree>
          <empty v-show="!cateLists.length" img-width="100px" />
        </div>
      </div>
    </div>
    <div class="material__center flex flex-col">
      <div class="operate-btn flex">
        <div class="flex-1 flex">
          <el-button size="small" @click="handleUpload">本地上传</el-button>
        </div>
      </div>
      <div class="material-center__content flex flex-col flex-1 min-h-0">
        <el-table
          ref="tableRef"
          class=""
          :data="pager.lists"
          width="100%"
          height="100%"
          size="large"
          @row-click="handleRowClick"
          @scroll.native="handleScrollTable"
        >
          <template slot="empty">
            <empty />
          </template>
          <el-table-column width="25">
            <template #default="{ row }">
              <el-checkbox
                v-model="row.isChecked"
                :disabled="forbidSelect.includes(row.id)"
                @change="(val) => changeChecked(row, val)"
              />
            </template>
          </el-table-column>
          <el-table-column
            v-for="item in tableColumn || []"
            :key="item.field"
            :label="item.label"
            :width="item.width"
            :fixed="item.field === 'handle' ? 'right' : null"
          >
            <template v-if="item.type === 'file'" #default="{ row }">
              <file-item
                :uri="zipImage(row[item.field])"
                width="80px"
                height="45px"
                :type="type"
                @preview="handlePreview"
              />
            </template>
            <template v-else-if="item.type === 'wh'" #default="{ row }">
              <div>宽：{{ row.img_width }}</div>
              <div>高：{{ row.img_height }}</div>
            </template>
            <template v-else-if="item.type === 'size'" #default="{ row }">
              {{ row.file_size | fileSizeFilter(row.storage_type) }}
            </template>
            <template v-else-if="item.type === 'name'" #default="{ row }">
              <div class="name-area">
                <el-image
                  style="width: 20px; height: 20px"
                  :src="thumbnail(row)"
                  fit="contain"
                />
                <div class="ellipsis name-link">
                  {{ row[item.field] + row.file_ext }}
                </div>
                <!-- <el-link
                  :underline="false"
                  @click.stop="handlePreview(row.url)"
                >
                  <div class="ellipsis name-link">
                    {{ row[item.field] + row.file_ext }}
                  </div>
                </el-link> -->
              </div>
            </template>
            <template v-else-if="item.type === 'file_type'" #default="{ row }">
              <el-image
                style="width: 90px; height: 45px"
                :src="thumbnail(row)"
                fit="contain"
              />
            </template>
            <template v-else #default="{ row }">
              {{ row[item.field] }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="material-center__footer flex justify-between items-center">
        <el-pagination
          class="page-wrap"
          :page-size="pager.size"
          layout="prev, pager, next"
          :current-page="pager.page"
          :total="pager.count"
          @current-change="handleChangePage"
        />
      </div>
    </div>
    <div class="material__right" v-if="limit > 1">
      <div class="flex justify-between flex-wrap">
        <div class="sm flex items-center">
          已选择 {{ select.length }}
          <span v-if="limit">/{{ limit }}</span>
        </div>
        <el-button type="text" @click="clearSelect">清空</el-button>
      </div>
      <div
        class="flex-1 min-h-0 scrollbar-style"
        style="height: 100%; overflow: auto"
      >
        <ul class="select-lists flex flex-col">
          <li
            v-for="item in select"
            :key="item.id"
            class=""
            :class="{ 'li-name': type === 'file' }"
          >
            <div class="select-item">
              <del-wrap v-if="type !== 'file'" @close="cancelSelete(item.id)">
                <file-item
                  :uri="zipImage(item.url)"
                  width="160px"
                  height="90px"
                  :type="type"
                />
              </del-wrap>
              <del-wrap
                v-else
                class="select-name"
                @close="cancelSelete(item.id)"
              >
                <p style="line-height: 28px; width: 100%">
                  {{ item.material_name + (item.file_ext || "") }}
                </p>
              </del-wrap>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <upload-file-dialog
      :visible="uploadVisible"
      :type="typeValue"
      :append-body="true"
      :save-id="cateId"
      :folder-path="folderPath"
      @close="closeUploadDialog"
      @success="uploadSuccess"
    />
    <preview v-model="showPreview" :url="previewUrl" :type="type" />
  </div>
</template>

<script>
import FileItem from "./file.vue";
import DelWrap from "../DelWrap/index.vue";
import Preview from "./preview.vue";
import {
  getMaterialTree,
  getFolderList,
} from "@saas/service-api/src/material/index.js";
import UploadFileDialog from "../UploadFileDialog";
import DynamicTooltip from "../DynamicTooltip";
import { checkPermission } from "@saas/components/src/utils/permission";
export default {
  components: {
    FileItem,
    DelWrap,
    UploadFileDialog,
    Preview,
    DynamicTooltip,
  },
  filters: {
    // 文件大小
    fileSizeFilter(size, type) {
      if (type === 1) {
        return "-";
      }
      if (size < 1024) {
        return `${size}B`;
      } else if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)}KB`;
      } else if (size < 1024 * 1024 * 1024) {
        return `${(size / (1024 * 1024)).toFixed(2)}MB`;
      } else {
        return `${(size / (1024 * 1024 * 1024)).toFixed(2)}GB`;
      }
    },
  },
  props: {
    fileSize: {
      type: String,
      default: "100px",
    },
    limit: {
      type: Number,
      default: 1,
    },
    type: {
      type: String,
      default: "image",
    },
    mode: {
      type: String,
      default: "picker",
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    isAdmin: {
      type: Boolean,
      default: false,
    },
    //  禁止选中的文件
    forbidSelect: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      uploadVisible: false,
      previewUrl: "",
      showPreview: false,
      treeRef: null,
      cateId: "",
      cateLists: [],
      pager: {
        page: 1,
        size: 10,
        loading: false,
        count: 0,
        lists: [],
      },
      tableRef: null,
      moveId: 0,
      select: [],
      isCheckAll: false,
      isIndeterminate: false,
      fileParams: {
        name: "",
        type: "",
        cid: "",
      },
      folderPath: [],
      pptPic: require("../../../assets/images/ppt.png"),
      pdfPic: require("../../../assets/images/pdf.png"),
      docPic: require("../../../assets/images/doc.png"),
      xlsPic: require("../../../assets/images/xls.png"),
      txtPic: require("../../../assets/images/txt.png"),
    };
  },
  computed: {
    handlePermission() {
      return checkPermission("action:material:file:manage");
    },
    typeValue() {
      switch (this.type) {
        case "image":
          return 3;
        case "video":
          return 1;
        case "file":
          return 2;
        default:
          return 0;
      }
    },
    tableColumn() {
      if (this.type === "image") {
        return [
          {
            field: "url",
            label: "图片",
            type: "file",
            width: 100,
          },
          {
            field: "material_name",
            label: "名称",
            type: "name",
          },
          {
            label: "尺寸",
            type: "wh",
          },
        ];
      } else if (this.type === "video") {
        return [
          {
            field: "url",
            label: "图片",
            type: "file",
            width: 100,
          },
          {
            field: "material_name",
            label: "名称",
            type: "name",
          },
        ];
      } else {
        return [
          // {
          //   field: "file_ext",
          //   label: "文档类型",
          //   type: "file_type",
          //   width: 100,
          // },
          {
            field: "material_name",
            label: "名称",
            type: "name",
          },
          {
            field: "file_size",
            label: "大小",
            type: "size",
            width: 68,
          },
        ];
      }
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          console.log(val);
          this.getData();
        }
      },
      immediate: true,
    },
    cateId() {
      this.fileParams.name = "";
      this.foldPath = [
        {
          id: this.cateId,
        },
        {
          id: 0,
        },
      ];
      this.refresh();
    },
    select: {
      handler(val) {
        this.$emit("change", val);
        if (val.length === this.pager?.lists?.length && val.length !== 0) {
          this.isIndeterminate = false;
          this.isCheckAll = true;
          return;
        }
        if (val.length > 0) {
          this.isIndeterminate = true;
        } else {
          this.isCheckAll = false;
          this.isIndeterminate = false;
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.$refs.tableRef.bodyWrapper.addEventListener('scroll', (res) => {
    //   const height = res.target
    //   const clientHeight = height.clientHeight
    //   const scrollTop = height.scrollTop
    //   const scrollHeight = height.scrollHeight
    //   if (clientHeight + scrollTop === scrollHeight && !this.pager.loading) {
    //     this.pager.page += 1
    //     this.getFileList()
    //   }
    // }, true)
  },
  methods: {
    // 压缩图片
    zipImage(url) {
      if (this.type === "image") {
        return url + "?imageView2/0/w/200/h/0/q/100";
      } else {
        return url;
      }
    },
    thumbnail(row) {
      if ([".doc", ".docx"].includes(row.file_ext.toLowerCase())) {
        return this.docPic;
      } else if ([".pdf"].includes(row.file_ext.toLowerCase())) {
        return this.pdfPic;
      } else if ([".ppt", ".pptx"].includes(row.file_ext.toLowerCase())) {
        return this.pptPic;
      } else if ([".xlsx", ".xls"].includes(row.file_ext.toLowerCase())) {
        return this.xlsPic;
      } else if ([".txt"].includes(row.file_ext.toLowerCase())) {
        return this.txtPic;
      } else {
        return this.txtPic;
      }
    },
    async getData() {
      await this.getCateLists();
      this.$refs["treeRef"]?.setCurrentKey(this.cateId);
      this.getFileList();
    },
    // 获取目录树
    async getCateLists() {
      const getTreeFn = getMaterialTree;
      const { data, code, message } = await getTreeFn({
        material_type: this.typeValue,
      });
      if (code === 1) {
        this.cateLists = [
          {
            id: 0,
            material_name: "根目录",
            Child: data || [],
          },
        ];
        this.$nextTick(() => {
          this.$refs["treeRef"]?.setCurrentKey(this.cateId);
        });
      } else {
        this.$message.error(message);
      }
    },
    // 获取文件列表
    getFileList() {
      this.pager.loading = true;
      const params = {
        id: this.cateId || "",
        material_type: this.typeValue,
        page: this.pager.page,
        pageSize: this.pager.size,
        storageType: 2,
      };
      const getFolderListFn = getFolderList;
      getFolderListFn({
        ...params,
      })
        .then((res) => {
          if (res.code === 1) {
            this.pager.count = res.data.total;
            this.pager.lists = res.data.data.map((item) => {
              return {
                isChecked: this.isSelect(item),
                ...item,
              };
            });
            this.pager.loading = false;
          } else {
            this.$message.error(res.message);
          }
        })
        .catch(() => {
          this.pager.loading = false;
        });
    },
    // 删除选择的文件
    cancelSelete(id) {
      this.select = this.select.filter((item) => item.id !== id);
      this.pager.lists.forEach((element) => {
        if (element.id === id) {
          element.isChecked = false;
        }
      });
    },
    // 清空
    clearSelect() {
      this.select = [];
      this.pager.lists.forEach((element) => {
        element.isChecked = false;
      });
    },
    // 选中分类
    handleCatSelect(item) {
      this.cateId = item.id;
    },
    // 请求第一页数据
    refresh() {
      this.pager.page = 1;
      this.getFileList();
    },
    // 预览
    handlePreview(url) {
      console.log(url);
      this.previewUrl = url;
      // this.showPreview = true;
    },
    isSelect(data) {
      const { id } = data;
      const index = this.select?.findIndex((item) => item.id === id);
      if (index !== -1) {
        this.select[index] = data;
      }
      return index !== -1;
    },

    closeUploadDialog() {
      //   this.appendBody = true
      this.uploadVisible = false;
    },
    uploadSuccess(val) {
      val.forEach((item) => {
        item.file_size = item.raw?.size;
        item.material_name = item.name;
      });
      if (val.length) {
        if (this.limit === 1) {
          this.select = [val[0]];
        } else {
          const count = this.limit - this.select.length;
          if (count > 0) {
            this.select = [...this.select, ...val.slice(0, count)];
          } else {
            this.$message.error("已达到选择上限");
          }
        }
      }
      this.uploadVisible = false;
      this.getFileList();
    },
    handleUpload() {
      if (this.handlePermission) {
        this.uploadVisible = true;
      } else {
        this.$message.error(
          "您没有上传文件到文档素材的权限，请联系你们的管理员。"
        );
      }
    },
    // 切换页码
    handleChangePage(page) {
      this.pager.page = page;
      this.getFileList();
    },
    batchFileDelete: async (id) => {
      this.getFileList();
      this.clearSelect();
    },
    // 点击表格选择或取消选择文件
    selectFile(item) {
      if (item.isChecked) {
        if (this.select.length === this.limit) {
          if (this.limit === 1) {
            // 如果限制一条，则自动覆盖
            this.pager.lists.forEach((element) => {
              if (item.id !== element.id) {
                element.isChecked = false;
              }
            });
            this.select = [];
            this.select.push(item);
            return;
          }
          this.$message.warning("已达到选择上限");
          item.isChecked = false;
          return;
        }
        this.select.push(item);
      } else {
        const index = this.select.findIndex(
          (element) => element.id === item.id
        );
        if (index !== -1) {
          this.select.splice(index, 1);
          return;
        }
      }
    },
    async handleFileRename(value, id) {
      // await fileRename({
      //   id,
      //   name: value
      // })
      this.getFileList();
    },
    changeChecked(row, val) {
      if (this.forbidSelect.includes(row.id)) {
        return;
      }
      this.$nextTick(() => {
        this.selectFile(row);
      });
    },
    handleRowClick(row, column, event) {
      if (this.forbidSelect.includes(row.id)) {
        return;
      }
      if (event.target.nodeName === "TD" || event.target.nodeName === "DIV") {
        row.isChecked = !row.isChecked;
        this.selectFile(row);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.material {
  height: 100%;
  .material-left__content {
    height: 100%;
    overflow: auto;
    .el-tree {
      background: unset;
      ::v-deep .el-tree-node {
        .is-current {
          // background: red;
        }
      }
    }
  }
  .ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    /* 调整这里的数值以适应需要显示的行数 */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  display: flex;
  // @apply h-full min-h-0 flex flex-1;

  &__left {
    border-right: 1px solid var(--select-file-border);
    display: flex;
    flex-direction: column;
    width: 180px;
    ::v-deep(.el-tree) {
      color: var(--select-file-secondary);
    }
    ::v-deep(.el-tree-node__content) {
      height: 36px;
      color: var(--select-file-secondary);
      &:hover {
        background: var(--select-file-control-hover-bg);
        color: var(--select-file-text);
      }
    }
    ::v-deep(.el-tree-node:focus > .el-tree-node__content) {
      background: var(--select-file-control-hover-bg);
    }
    ::v-deep(
        .el-tree--highlight-current
          .el-tree-node.is-current
          > .el-tree-node__content
      ) {
      background: var(--select-file-control-active-bg);
      color: var(--select-file-text);
    }
  }

  &__center {
    flex: 1;
    min-width: 0;
    min-height: 0;
    padding: 16px 16px 0;
    .operate-btn {
      .el-button {
        height: 30px;
        background: var(--select-file-control-bg);
        border-radius: 8px;
        border: 1px solid var(--select-file-border);
        width: 90px;
        font-weight: 600;
        font-size: 14px;
        color: var(--mg-brand-primary);
        padding: 0;
      }
    }
    .el-table {
      background: unset;
    }
    ::v-deep .el-table__header-wrapper {
      border-radius: 8px;
      th {
        border: none;
        background-color: var(--select-file-table-header-bg);
        padding: 0;
        font-weight: 400;
        font-size: 12px;
        color: var(--select-file-secondary);
      }
    }
    ::v-deep .el-table__row {
      cursor: pointer;

      .cell {
        padding-left: 0;
        padding-right: 0;
      }
      td {
        border: none;
        background: var(--select-file-surface-bg);
        color: var(--select-file-text);
      }
      &:hover > td {
        background: var(--select-file-control-hover-bg);
      }
    }
    .list-icon {
      border-radius: 3px;
      display: flex;
      padding: 5px;
      cursor: pointer;

      &.select {
        // @apply text-primary bg-primary-light-8;
      }
    }

    .file-list {
      .file-item-wrap {
        margin-right: 16px;
        line-height: 1.3;
        cursor: pointer;

        .item-selected {
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          background-color: rgba(0, 0, 0, 0.5);
          box-sizing: border-box;
        }

        .operation-btns {
          height: 28px;
          visibility: hidden;
        }

        &:hover .operation-btns {
          visibility: visible;
        }
      }
    }
    .name-area {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      .name-link {
        margin-left: 10px;
        width: 336px;
      }
    }
  }
  .page-wrap ::v-deep {
    button {
      background: var(--select-file-pagination-bg);
      color: var(--select-file-secondary);
      &:hover {
        color: var(--mg-brand-primary);
      }
      &:disabled {
        background: var(--select-file-pagination-bg);
        color: var(--select-file-muted);
      }
    }
    li {
      background: var(--select-file-pagination-bg);
      color: var(--select-file-secondary);
      font-weight: normal;
      &:hover,
      &.active {
        color: var(--mg-brand-primary);
      }
    }
  }

  &__right {
    // @apply border-l border-br flex flex-col;
    width: 190px;
    .select-lists {
      padding: 10px;
      li {
        margin: 0 auto;
        margin-bottom: 4px;
      }
      .li-name {
        width: 100%;
        .select-name {
          width: 100%;
          margin: 0 auto;
          margin-bottom: 4px;
          background-color: var(--select-file-control-bg);
          color: var(--select-file-text);
          border-radius: 4px;
          padding: 0 6px;
        }
      }
    }
  }
}
</style>
